import http from "../../http-common-super-admin";

class LogsService {
    GetLogs(data) {
      return http.get("logs/enroll-device", { params: data });
    }
}

export default new LogsService();